/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddCvSearchCandidateTagRequestDto } from '../models';
// @ts-ignore
import type { CvSearchCandidateProfileDto } from '../models';
// @ts-ignore
import type { CvSearchErrorProblemDto } from '../models';
// @ts-ignore
import type { GetCvSearchCandidateTagsResponseDto } from '../models';
/**
 * CvSearchCandidateProfileRestApi - axios parameter creator
 */
export const CvSearchCandidateProfileRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ręczna edycja tagów CVSearch: tworzy przypisanie o źródle `manual` dla wartości słownikowej wskazanej przez `tagValueId` (wartość musi istnieć w słowniku CVSearch). Kandydat musi mieć mapowanie na dane w CVSearch. Idempotentne. 
         * @summary Add a manual tag assignment for the candidate in CV Search
         * @param {string} candidateId 
         * @param {AddCvSearchCandidateTagRequestDto} addCvSearchCandidateTagRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCvSearchCandidateTag: async (candidateId: string, addCvSearchCandidateTagRequestDto: AddCvSearchCandidateTagRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('addCvSearchCandidateTag', 'candidateId', candidateId)
            // verify required parameter 'addCvSearchCandidateTagRequestDto' is not null or undefined
            assertParamExists('addCvSearchCandidateTag', 'addCvSearchCandidateTagRequestDto', addCvSearchCandidateTagRequestDto)
            const localVarPath = `/api/v1/cv-search/candidates/{candidateId}/cv-search-tags/add`
                .replace('{candidateId}', encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/problem+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCvSearchCandidateTagRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ręczna edycja tagów CVSearch: usuwa wszystkie przypisania tagu wskazanego przez `tagValueId` dla kandydata i zapisuje wpis na liście usunięć (także dla tagu ręcznego `manual`), dzięki czemu ponowne tagowanie ani zadania naprawcze nie przywrócą wartości. Ponowne ręczne dodanie wartości czyści wpis na liście usunięć. Powtórne usunięcie tej samej pary jest bezpieczne (idempotentne). Kandydat musi mieć mapowanie na dane w CVSearch, a wartość musi istnieć w słowniku CVSearch. 
         * @summary Remove a tag assignment for the candidate in CV Search
         * @param {string} candidateId 
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSearchCandidateTag: async (candidateId: string, tagValueId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('deleteCvSearchCandidateTag', 'candidateId', candidateId)
            // verify required parameter 'tagValueId' is not null or undefined
            assertParamExists('deleteCvSearchCandidateTag', 'tagValueId', tagValueId)
            const localVarPath = `/api/v1/cv-search/candidates/{candidateId}/cv-search-tags/{tagValueId}`
                .replace('{candidateId}', encodeURIComponent(String(candidateId)))
                .replace('{tagValueId}', encodeURIComponent(String(tagValueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a candidate profile for the CV Search panel
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchCandidateProfile: async (candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('getCvSearchCandidateProfile', 'candidateId', candidateId)
            const localVarPath = `/api/v1/cv-search/candidates/{candidateId}/profile`
                .replace('{candidateId}', encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zwraca `mapped=false` (200) wyłącznie gdy kandydat nie ma mapowania na dane w CVSearch - wtedy UI ukrywa kontrolki edycji tagów. Gdy odczyt tagów z CVSearch kończy się błędem (niedostępność, timeout, odpowiedź 5xx) lub zmapowany kandydat nie istnieje w CVSearch, błąd jest propagowany (502 / 404) zamiast maskowania pustą listą tagów. 
         * @summary Get tags granted to the candidate by the CV Search tagging pipeline
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchCandidateTags: async (candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('getCvSearchCandidateTags', 'candidateId', candidateId)
            const localVarPath = `/api/v1/cv-search/candidates/{candidateId}/cv-search-tags`
                .replace('{candidateId}', encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zleca w CVSearch ponowne tagowanie CV kandydata. Tagowanie jest asynchroniczne, nowe tagi pojawiają się po przetworzeniu zadania. Tagi ręczne (`manual`) i wpisy z listy usunięć zostają nienaruszone. Kandydat musi mieć mapowanie na dane w CVSearch. 
         * @summary Request CV Search to tag the candidate\'s CV again
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retagCvSearchCandidate: async (candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('retagCvSearchCandidate', 'candidateId', candidateId)
            const localVarPath = `/api/v1/cv-search/candidates/{candidateId}/cv-search-tags/retag`
                .replace('{candidateId}', encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CvSearchCandidateProfileRestApi - functional programming interface
 */
export const CvSearchCandidateProfileRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CvSearchCandidateProfileRestApiAxiosParamCreator(configuration)
    return {
        /**
         * Ręczna edycja tagów CVSearch: tworzy przypisanie o źródle `manual` dla wartości słownikowej wskazanej przez `tagValueId` (wartość musi istnieć w słowniku CVSearch). Kandydat musi mieć mapowanie na dane w CVSearch. Idempotentne. 
         * @summary Add a manual tag assignment for the candidate in CV Search
         * @param {string} candidateId 
         * @param {AddCvSearchCandidateTagRequestDto} addCvSearchCandidateTagRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCvSearchCandidateTag(candidateId: string, addCvSearchCandidateTagRequestDto: AddCvSearchCandidateTagRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCvSearchCandidateTag(candidateId, addCvSearchCandidateTagRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CvSearchCandidateProfileRestApi.addCvSearchCandidateTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ręczna edycja tagów CVSearch: usuwa wszystkie przypisania tagu wskazanego przez `tagValueId` dla kandydata i zapisuje wpis na liście usunięć (także dla tagu ręcznego `manual`), dzięki czemu ponowne tagowanie ani zadania naprawcze nie przywrócą wartości. Ponowne ręczne dodanie wartości czyści wpis na liście usunięć. Powtórne usunięcie tej samej pary jest bezpieczne (idempotentne). Kandydat musi mieć mapowanie na dane w CVSearch, a wartość musi istnieć w słowniku CVSearch. 
         * @summary Remove a tag assignment for the candidate in CV Search
         * @param {string} candidateId 
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSearchCandidateTag(candidateId: string, tagValueId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCvSearchCandidateTag(candidateId, tagValueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CvSearchCandidateProfileRestApi.deleteCvSearchCandidateTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a candidate profile for the CV Search panel
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSearchCandidateProfile(candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchCandidateProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvSearchCandidateProfile(candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CvSearchCandidateProfileRestApi.getCvSearchCandidateProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zwraca `mapped=false` (200) wyłącznie gdy kandydat nie ma mapowania na dane w CVSearch - wtedy UI ukrywa kontrolki edycji tagów. Gdy odczyt tagów z CVSearch kończy się błędem (niedostępność, timeout, odpowiedź 5xx) lub zmapowany kandydat nie istnieje w CVSearch, błąd jest propagowany (502 / 404) zamiast maskowania pustą listą tagów. 
         * @summary Get tags granted to the candidate by the CV Search tagging pipeline
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSearchCandidateTags(candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCvSearchCandidateTagsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvSearchCandidateTags(candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CvSearchCandidateProfileRestApi.getCvSearchCandidateTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zleca w CVSearch ponowne tagowanie CV kandydata. Tagowanie jest asynchroniczne, nowe tagi pojawiają się po przetworzeniu zadania. Tagi ręczne (`manual`) i wpisy z listy usunięć zostają nienaruszone. Kandydat musi mieć mapowanie na dane w CVSearch. 
         * @summary Request CV Search to tag the candidate\'s CV again
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retagCvSearchCandidate(candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retagCvSearchCandidate(candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CvSearchCandidateProfileRestApi.retagCvSearchCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CvSearchCandidateProfileRestApi - factory interface
 */
export const CvSearchCandidateProfileRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CvSearchCandidateProfileRestApiFp(configuration)
    return {
        /**
         * Ręczna edycja tagów CVSearch: tworzy przypisanie o źródle `manual` dla wartości słownikowej wskazanej przez `tagValueId` (wartość musi istnieć w słowniku CVSearch). Kandydat musi mieć mapowanie na dane w CVSearch. Idempotentne. 
         * @summary Add a manual tag assignment for the candidate in CV Search
         * @param {string} candidateId 
         * @param {AddCvSearchCandidateTagRequestDto} addCvSearchCandidateTagRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCvSearchCandidateTag(candidateId: string, addCvSearchCandidateTagRequestDto: AddCvSearchCandidateTagRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCvSearchCandidateTag(candidateId, addCvSearchCandidateTagRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Ręczna edycja tagów CVSearch: usuwa wszystkie przypisania tagu wskazanego przez `tagValueId` dla kandydata i zapisuje wpis na liście usunięć (także dla tagu ręcznego `manual`), dzięki czemu ponowne tagowanie ani zadania naprawcze nie przywrócą wartości. Ponowne ręczne dodanie wartości czyści wpis na liście usunięć. Powtórne usunięcie tej samej pary jest bezpieczne (idempotentne). Kandydat musi mieć mapowanie na dane w CVSearch, a wartość musi istnieć w słowniku CVSearch. 
         * @summary Remove a tag assignment for the candidate in CV Search
         * @param {string} candidateId 
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSearchCandidateTag(candidateId: string, tagValueId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCvSearchCandidateTag(candidateId, tagValueId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a candidate profile for the CV Search panel
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchCandidateProfile(candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchCandidateProfileDto> {
            return localVarFp.getCvSearchCandidateProfile(candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Zwraca `mapped=false` (200) wyłącznie gdy kandydat nie ma mapowania na dane w CVSearch - wtedy UI ukrywa kontrolki edycji tagów. Gdy odczyt tagów z CVSearch kończy się błędem (niedostępność, timeout, odpowiedź 5xx) lub zmapowany kandydat nie istnieje w CVSearch, błąd jest propagowany (502 / 404) zamiast maskowania pustą listą tagów. 
         * @summary Get tags granted to the candidate by the CV Search tagging pipeline
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchCandidateTags(candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchCandidateTagsResponseDto> {
            return localVarFp.getCvSearchCandidateTags(candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Zleca w CVSearch ponowne tagowanie CV kandydata. Tagowanie jest asynchroniczne, nowe tagi pojawiają się po przetworzeniu zadania. Tagi ręczne (`manual`) i wpisy z listy usunięć zostają nienaruszone. Kandydat musi mieć mapowanie na dane w CVSearch. 
         * @summary Request CV Search to tag the candidate\'s CV again
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retagCvSearchCandidate(candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.retagCvSearchCandidate(candidateId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CvSearchCandidateProfileRestApi - interface
 */
export interface CvSearchCandidateProfileRestApiInterface {
    /**
     * Ręczna edycja tagów CVSearch: tworzy przypisanie o źródle `manual` dla wartości słownikowej wskazanej przez `tagValueId` (wartość musi istnieć w słowniku CVSearch). Kandydat musi mieć mapowanie na dane w CVSearch. Idempotentne. 
     * @summary Add a manual tag assignment for the candidate in CV Search
     * @param {string} candidateId 
     * @param {AddCvSearchCandidateTagRequestDto} addCvSearchCandidateTagRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCvSearchCandidateTag(candidateId: string, addCvSearchCandidateTagRequestDto: AddCvSearchCandidateTagRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Ręczna edycja tagów CVSearch: usuwa wszystkie przypisania tagu wskazanego przez `tagValueId` dla kandydata i zapisuje wpis na liście usunięć (także dla tagu ręcznego `manual`), dzięki czemu ponowne tagowanie ani zadania naprawcze nie przywrócą wartości. Ponowne ręczne dodanie wartości czyści wpis na liście usunięć. Powtórne usunięcie tej samej pary jest bezpieczne (idempotentne). Kandydat musi mieć mapowanie na dane w CVSearch, a wartość musi istnieć w słowniku CVSearch. 
     * @summary Remove a tag assignment for the candidate in CV Search
     * @param {string} candidateId 
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCvSearchCandidateTag(candidateId: string, tagValueId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get a candidate profile for the CV Search panel
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvSearchCandidateProfile(candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchCandidateProfileDto>;

    /**
     * Zwraca `mapped=false` (200) wyłącznie gdy kandydat nie ma mapowania na dane w CVSearch - wtedy UI ukrywa kontrolki edycji tagów. Gdy odczyt tagów z CVSearch kończy się błędem (niedostępność, timeout, odpowiedź 5xx) lub zmapowany kandydat nie istnieje w CVSearch, błąd jest propagowany (502 / 404) zamiast maskowania pustą listą tagów. 
     * @summary Get tags granted to the candidate by the CV Search tagging pipeline
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvSearchCandidateTags(candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchCandidateTagsResponseDto>;

    /**
     * Zleca w CVSearch ponowne tagowanie CV kandydata. Tagowanie jest asynchroniczne, nowe tagi pojawiają się po przetworzeniu zadania. Tagi ręczne (`manual`) i wpisy z listy usunięć zostają nienaruszone. Kandydat musi mieć mapowanie na dane w CVSearch. 
     * @summary Request CV Search to tag the candidate\'s CV again
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retagCvSearchCandidate(candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * CvSearchCandidateProfileRestApi - object-oriented interface
 */
export class CvSearchCandidateProfileRestApi extends BaseAPI implements CvSearchCandidateProfileRestApiInterface {
    /**
     * Ręczna edycja tagów CVSearch: tworzy przypisanie o źródle `manual` dla wartości słownikowej wskazanej przez `tagValueId` (wartość musi istnieć w słowniku CVSearch). Kandydat musi mieć mapowanie na dane w CVSearch. Idempotentne. 
     * @summary Add a manual tag assignment for the candidate in CV Search
     * @param {string} candidateId 
     * @param {AddCvSearchCandidateTagRequestDto} addCvSearchCandidateTagRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCvSearchCandidateTag(candidateId: string, addCvSearchCandidateTagRequestDto: AddCvSearchCandidateTagRequestDto, options?: RawAxiosRequestConfig) {
        return CvSearchCandidateProfileRestApiFp(this.configuration).addCvSearchCandidateTag(candidateId, addCvSearchCandidateTagRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ręczna edycja tagów CVSearch: usuwa wszystkie przypisania tagu wskazanego przez `tagValueId` dla kandydata i zapisuje wpis na liście usunięć (także dla tagu ręcznego `manual`), dzięki czemu ponowne tagowanie ani zadania naprawcze nie przywrócą wartości. Ponowne ręczne dodanie wartości czyści wpis na liście usunięć. Powtórne usunięcie tej samej pary jest bezpieczne (idempotentne). Kandydat musi mieć mapowanie na dane w CVSearch, a wartość musi istnieć w słowniku CVSearch. 
     * @summary Remove a tag assignment for the candidate in CV Search
     * @param {string} candidateId 
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCvSearchCandidateTag(candidateId: string, tagValueId: number, options?: RawAxiosRequestConfig) {
        return CvSearchCandidateProfileRestApiFp(this.configuration).deleteCvSearchCandidateTag(candidateId, tagValueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a candidate profile for the CV Search panel
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvSearchCandidateProfile(candidateId: string, options?: RawAxiosRequestConfig) {
        return CvSearchCandidateProfileRestApiFp(this.configuration).getCvSearchCandidateProfile(candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zwraca `mapped=false` (200) wyłącznie gdy kandydat nie ma mapowania na dane w CVSearch - wtedy UI ukrywa kontrolki edycji tagów. Gdy odczyt tagów z CVSearch kończy się błędem (niedostępność, timeout, odpowiedź 5xx) lub zmapowany kandydat nie istnieje w CVSearch, błąd jest propagowany (502 / 404) zamiast maskowania pustą listą tagów. 
     * @summary Get tags granted to the candidate by the CV Search tagging pipeline
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvSearchCandidateTags(candidateId: string, options?: RawAxiosRequestConfig) {
        return CvSearchCandidateProfileRestApiFp(this.configuration).getCvSearchCandidateTags(candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zleca w CVSearch ponowne tagowanie CV kandydata. Tagowanie jest asynchroniczne, nowe tagi pojawiają się po przetworzeniu zadania. Tagi ręczne (`manual`) i wpisy z listy usunięć zostają nienaruszone. Kandydat musi mieć mapowanie na dane w CVSearch. 
     * @summary Request CV Search to tag the candidate\'s CV again
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retagCvSearchCandidate(candidateId: string, options?: RawAxiosRequestConfig) {
        return CvSearchCandidateProfileRestApiFp(this.configuration).retagCvSearchCandidate(candidateId, options).then((request) => request(this.axios, this.basePath));
    }
}

